var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14436 33.6814L2.14429 33.6815C1.59089 34.2351 1.28 34.9858 1.28 35.7685C1.28 36.5513 1.59088 37.302 2.14429 37.8556L2.14444 37.8557C2.69801 38.4091 3.44872 38.72 4.23146 38.72C5.01421 38.72 5.76491 38.4091 6.31848 37.8557L6.31855 37.8556L20.0135 24.1607L33.7084 37.8556L33.7083 37.8557L33.7173 37.8644C34.2741 38.4021 35.0197 38.6997 35.7937 38.6929C36.5677 38.6862 37.3081 38.3758 37.8554 37.8284C38.4027 37.2811 38.7132 36.5408 38.7199 35.7668C38.7266 34.9928 38.4291 34.2471 37.8914 33.6904L37.8914 33.6903L37.8826 33.6814L24.1877 19.9865L37.8826 6.2916L37.8827 6.29168L37.8914 6.28268C38.4291 5.72594 38.7266 4.98027 38.7199 4.20628C38.7132 3.43229 38.4027 2.69192 37.8554 2.1446C37.3081 1.59729 36.5677 1.28684 35.7937 1.28011C35.0197 1.27339 34.2741 1.57092 33.7173 2.10864L33.7172 2.10856L33.7084 2.11741L20.0135 15.8123L6.31855 2.11741L6.31863 2.11734L6.30963 2.10864C5.75289 1.57092 5.00722 1.27339 4.23323 1.28011C3.45924 1.28684 2.71886 1.59729 2.17155 2.1446C1.62424 2.69191 1.31379 3.43229 1.30706 4.20628C1.30034 4.98027 1.59787 5.72594 2.13559 6.28268L2.13552 6.28275L2.14436 6.2916L15.8393 19.9865L2.14436 33.6814Z",
    fill: "#020202",
    stroke: "#020202",
    strokeWidth: 1.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.0466286557f30e16eff95ad696d89de0.svg";
export { ForwardRef as ReactComponent };